
import { translate } from "react-i18next";
import * as React from "react";

import { Button, ButtonGroup, Tooltip, TooltipBody } from "@wg/wows-react-uikit";
import { hasPermission, permissions, roleNames } from "../../../roles";

type IProps = {
  clanId: number;
  roleName: string;
  selectedMembersLength: number;
  isDisabled: boolean;

  onRemoveMembersClick: () => void;
  onChangeCommanderClick: () => void;
  onChangeRoleClick: () => void;

  t: (arg0: string) => string;
};

class MembersControlBlock extends React.PureComponent<IProps> {

  render() {
    const props = this.props;
    const t = props.t;

    let buttonChangeRole = null,
        buttonChangeCommander = null,
        buttonRemoveMember = null;

    if (hasPermission(props.roleName, permissions.CHANGE_ROLE)) {
      const isDisabled = props.selectedMembersLength < 1;
      let tooltipContent = null;
      if (isDisabled && !props.isDisabled) {
        tooltipContent = <Tooltip>
                        <TooltipBody>{t('Выберите одного или нескольких игроков')}</TooltipBody>
                    </Tooltip>;
      }

      buttonChangeRole = <Button key={`member-control-change-role-${props.clanId}`} isJustified isDisabled={isDisabled || props.isDisabled} onClick={() => props.onChangeRoleClick()} tooltipBody={tooltipContent}>
                    {t('Изменить должность')}
                </Button>;
    }

    if (hasPermission(props.roleName, permissions.CHANGE_COMMANDER)) {
      const isDisabled = props.selectedMembersLength !== 1;
      let tooltipContent = null;
      if (isDisabled && !props.isDisabled) {
        tooltipContent = <Tooltip>
                        <TooltipBody>{t('Выберите одного игрока для передачи управления кланом')}</TooltipBody>
                    </Tooltip>;
      }

      buttonChangeCommander = <Button key={`member-control-change-commander-${props.clanId}`} isJustified isDisabled={isDisabled || props.isDisabled} onClick={props.onChangeCommanderClick} tooltipBody={tooltipContent}>
                    {t('Передать управление')}
                </Button>;
    }

    if (hasPermission(props.roleName, permissions.REMOVE_MEMBER)) {
      const isDisabled = props.selectedMembersLength < 1;
      let tooltipContent = null;
      if (isDisabled && !props.isDisabled) {
        tooltipContent = <Tooltip>
                        <TooltipBody>{t('Выберите одного или нескольких игроков')}</TooltipBody>
                    </Tooltip>;
      }

      buttonRemoveMember = <Button key={`member-control-remove-member-${props.clanId}`} isJustified isDisabled={isDisabled || props.isDisabled} onClick={props.onRemoveMembersClick} tooltipBody={tooltipContent}>
                    {t('Исключить')}
                </Button>;
    }

    return <ButtonGroup>
                {buttonChangeRole}
                {buttonChangeCommander}
                {buttonRemoveMember}
            </ButtonGroup>;
  }
}

export default translate()(MembersControlBlock);